const currentState = {
    loading: false,
    geoInfo: null,
    timeZones: null,
    backGroundTask: {
        meetingAlerts: [],
        meetingFolderUpload: []
    },
    isBackgroundTaskOpen: false,
    pendingTasks: 0,
    successTask: 0,
    totalTasks: 0,
    failedTasks: 0,
    completeTasks: 0,
    companies: {
        data: null,
        error: false,
        companyLogo: '../../../../../../../assets/images/default-company-logo.png'
    },
    groups: {
        data: null,
        error: false
    }
};

const reducer = (state = currentState, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return {
                ...state,
                loading: true
            };
        case 'ADD_MEETING_ALERT_BACK_GROUND_TASK': {
            const backGroundTask = state.backGroundTask;
            const newBackGroundTask = action.payload;
            backGroundTask.meetingAlerts.push(newBackGroundTask)
            return {
                ...state,
                backGroundTask: backGroundTask,
                pendingTasks: state.pendingTasks + 1,
                totalTasks: state.totalTasks + 1
            }
        }
        case 'SUCCESS_MEETING_ALERT_BACK_GROUND_TASK': {
            const backGroundTask = state.backGroundTask;
            const newBackGroundTask = action.payload;

            backGroundTask.meetingAlerts = backGroundTask.meetingAlerts.map(alert => {
                const alertCopy = alert
                if (alertCopy.name === newBackGroundTask.name && alertCopy.meeting === newBackGroundTask.meeting) {
                    alertCopy.status = 'success'
                }
                return alertCopy
            })
            return {
                ...state,
                backGroundTask: backGroundTask,
                successTask: state.successTask + 1,
                pendingTasks: state.pendingTasks - 1,
                completeTasks: state.completeTasks + 1
            }
        }
        case 'FAILED_MEETING_ALERT_BACK_GROUND_TASK': {
            const backGroundTask = state.backGroundTask;
            const newBackGroundTask = action.payload;

            backGroundTask.meetingAlerts = backGroundTask.meetingAlerts.map(alert => {
                const alertCopy = alert
                if (alertCopy.name === newBackGroundTask.name && alertCopy.meeting === newBackGroundTask.meeting) {
                    alertCopy.status = newBackGroundTask.status
                    if (!alertCopy.body && !alertCopy.url) {
                        alertCopy['url'] = newBackGroundTask.url.concat(newBackGroundTask.id)
                        alertCopy['body'] = newBackGroundTask.body
                        alertCopy['id'] = newBackGroundTask.id

                    }
                }
                return alertCopy
            })
            return {
                ...state,
                backGroundTask: backGroundTask,
                failedTasks: state.failedTasks + 1,
                pendingTasks: state.pendingTasks - 1,
                completeTasks: state.completeTasks + 1
            }
        }
        case 'RESEND_MEETING_ALERT_BACK_GROUND_TASK': {
            const backGroundTask = state.backGroundTask;
            const newBackGroundTask = action.payload;

            backGroundTask.meetingAlerts = backGroundTask.meetingAlerts.map(alert => {
                const alertCopy = alert
                if (alertCopy.name === newBackGroundTask.name && alertCopy.meeting === newBackGroundTask.meeting) {
                    alertCopy.status = 'ongoing'
                }
                return alertCopy
            })
            return {
                ...state,
                backGroundTask: backGroundTask,
                failedTasks: state.failedTasks - 1,
                pendingTasks: state.pendingTasks + 1,
                completeTasks: state.completeTasks - 1
            }
        }
        case 'ADD_MEETING_UPLOAD_BACK_GROUND_TASK': {
            const backGroundTask = state.backGroundTask;
            const newBackGroundTask = action.payload;
            backGroundTask.meetingFolderUpload.push(newBackGroundTask)
            return {
                ...state,
                backGroundTask: backGroundTask,
                pendingTasks: state.pendingTasks + 1,
                totalTasks: state.totalTasks + 1
            }
        }
        case 'SUCCESS_MEETING_UPLOAD_BACK_GROUND_TASK': {
            const backGroundTask = state.backGroundTask;
            const newBackGroundTask = action.payload;

            backGroundTask.meetingFolderUpload = backGroundTask.meetingFolderUpload.map(alert => {
                const alertCopy = alert
                if (alertCopy.name === newBackGroundTask.name && alertCopy.meeting === newBackGroundTask.meeting) {
                    alertCopy.status = 'success'
                }
                return alertCopy
            })
            return {
                ...state,
                backGroundTask: backGroundTask,
                successTask: state.successTask + 1,
                pendingTasks: state.pendingTasks - 1,
                completeTasks: state.completeTasks + 1

            }
        }
        case 'FAILED_MEETING_UPLOAD_BACK_GROUND_TASK': {
            const backGroundTask = state.backGroundTask;
            const newBackGroundTask = action.payload;

            backGroundTask.meetingFolderUpload = backGroundTask.meetingFolderUpload.map(alert => {
                const alertCopy = alert
                if (alertCopy.name === newBackGroundTask.name && alertCopy.meeting === newBackGroundTask.meeting) {
                    alertCopy.status = 'failed'
                    alertCopy['uploadAgendaResourceUrl'] = newBackGroundTask.uploadAgendaResourceUrl
                    alertCopy['file'] = newBackGroundTask.file
                    alertCopy['id'] = newBackGroundTask.id
                    alertCopy['meetingFolder'] = newBackGroundTask.meetingFolder
                    alertCopy['type'] = newBackGroundTask.type ?? 'Other'
                }
                return alertCopy
            })
            return {
                ...state,
                backGroundTask: backGroundTask,
                failedTasks: state.failedTasks + 1,
                pendingTasks: state.pendingTasks - 1,
                completeTasks: state.completeTasks + 1

            }
        }
        case 'RESEND_MEETING_UPLOAD_BACK_GROUND_TASK': {
            const backGroundTask = state.backGroundTask;
            const newBackGroundTask = action.payload;

            backGroundTask.meetingFolderUpload = backGroundTask.meetingFolderUpload.map(alert => {
                const alertCopy = alert
                if (alertCopy.name === newBackGroundTask.name && alertCopy.meeting === newBackGroundTask.meeting) {
                    alertCopy.status = 'ongoing'
                }
                return alertCopy
            })
            return {
                ...state,
                backGroundTask: backGroundTask,
                failedTasks: state.failedTasks - 1,
                pendingTasks: state.pendingTasks + 1,
                completeTasks: state.completeTasks - 1

            }
        }
        case 'OPEN_BACKGROUND_TASK_MODAL':
            return {
                ...state,
                isBackgroundTaskOpen: true
            }
        case 'CLOSE_BACKGROUND_TASK_MODAL':
            return {
                ...state,
                isBackgroundTaskOpen: false
            }
        case 'REMOVE_LOADING':
            return {
                ...state,
                loading: false
            };
        case 'SET_GEO_INFO':
            return {
                ...state,
                geoInfo: action.payload
            };
        case 'CLEAR_GEO_INFO':
            return {
                ...state,
                geoInfo: null
            };
        case 'SET_TIME_ZONES':
            return {
                ...state,
                timeZones: action.payload
            };
        case 'CLEAR_TIME_ZONES':
            return {
                ...state,
                timeZones: null
            };
        case 'INSTANTIATE_COMPANIES': {
            const companies = { ...state.companies };
            companies.data = action.payload;

            return {
                ...state,
                companies: companies
            };
        }
        case 'INSTANTIATE_COMPANY_LOGO': {
            const companies = { ...state.companies };
            companies.companyLogo = action.payload;

            return {
                ...state,
                companies: companies
            };
        }
        case 'INSTANTIATE_COMPANIES_ERROR': {
            const companies = { ...state.companies };
            companies.error = true;

            return {
                ...state,
                companies: companies
            };
        }
        case 'INSTANTIATE_USER_GROUPS': {
            const groups = { ...state.groups };
            groups.data = action.payload;

            return {
                ...state,
                groups: groups
            };
        }
        case 'INSTANTIATE_USER_GROUPS_ERROR': {
            const groups = { ...state.groups };
            groups.error = true;

            return {
                ...state,
                groups: groups
            };
        }
        case 'CREATE_COMPANY': {
            const companies = { ...state.companies };
            const data = Object.assign([], companies.data);

            data.push(action.payload);
            companies.data = data;

            return {
                ...state,
                companies: companies
            };
        }
        case 'UPDATE_COMPANY': {
            const companies = { ...state.companies };
            const data = Object.assign([], companies.data);

            const index = data.findIndex(company => parseInt(company.id) === parseInt(action.payload.id));

            if (index >= 0)
                data.splice(index, 1, action.payload);

            companies.data = data;

            return {
                ...state,
                companies: companies
            };
        }
        case 'DROP_COMPANY': {
            const companies = { ...state.companies };
            const data = Object.assign([], companies.data);

            const index = data.findIndex(company => parseInt(company.id) === parseInt(action.payload.id));

            if (index >= 0)
                data.splice(index, 1);

            companies.data = data;

            return {
                ...state,
                companies: companies
            };
        }
        case 'CLEAR_COMPANIES': {
            const companies = { ...state.companies };

            companies.data = null;
            companies.error = false;

            return {
                ...state,
                companies: companies
            };
        }
        default:
            return state;
    }
};

export default reducer;